module.exports = __webpack_public_path__ + "img/hair_front_male_long_mask.acc374ee.png";